export const maxDiscountValidator = discount => {
  if (Number(discount) > 60) {
    return false;
  }
  return true;
};
